<template>
	<v-select
		v-model="currentValue"
		:items="currentOptions"
		:item-text="(i) => $t(`$currency.${i.name}`)"
		item-value="code"
		:label="label || $t('port')"
		:disabled="!ready || disabled"
		:loading="!ready && !disabled"
		:clearable="clearable"
		outlined
		clear-icon="icon-cross"
		append-icon="icon-angle-down"
		:rules="rules"
		:prepend-icon="prependIcon"
		@change="changeAction"
		:menu-props="{ offsetY: true }"
	/>
</template>

<script>
import remote from "../../data/remote";

export default {
	props: ["value", "options", "eager", "label", "clearable", "disabled", "rules", "prepend-icon"],
	data() {
		return {
			currentValue: null,
			currentOptions: [],
			ready: false,
		};
	},
	watch: {
		currentValue(val) {
			this.$emit("input", val);
		},
		value(val) {
			this.currentValue = val || null;
		},
		options(val) {
			this.handleProps();
		},
	},
	methods: {
		handleProps() {
			if (this.options) {
				this.currentOptions = this.options;
				this.ready = true;
			} else if (this.eager) this.loadOptions();
		},
		loadOptions() {
			remote.structures.getCurrencies({
				status: 1,
				onSuccess: (result) => {
					this.currentOptions = result.items;
					this.ready = true;
				},
			});
		},
		changeAction(code) {
			this.$emit(
				"change",
				this.currentOptions.find((i) => i.code === code)
			);
		},
	},
	created() {
		this.currentValue = this.value || null;
		this.handleProps();
	},
};
</script>
